// Composition warnings of the preview's browser check, in words for the person. They inform and never
// block: the check that fails an ad stays in `findings`.
const TEXTS: Readonly<Record<string, string>> = {
  BUTTON_COVERED: "Un botón queda tapado por otro elemento",
  ELEMENT_OUTSIDE_FORMAT: "Un elemento se sale del formato o queda cortado",
  TRANSIENT_OUTSIDE_FORMAT: "Durante una rotación o animación, una parte sale del formato por un momento",
  ARTWORK_LETTERBOXED: "Un arte queda con franjas: su caja tiene otra proporción y un fondo opaco detrás",
  IMAGE_FRAME_MISMATCH: "Una imagen no llena su caja y hay un fondo opaco detrás: revisa si se ven franjas",
  ARTWORK_CROPPED: "Una imagen se recorta porque su caja tiene otra proporción",
  IMAGE_DISTORTED: "Una imagen se deforma porque su caja tiene otra proporción",
  TEXT_TOO_SMALL: "Un texto mide menos de 11 px",
  CTA_EVENT_MISSING: "El botón de destino puede no registrar los clics",
  INTERACTION_EVENT_MISSING: "El anuncio responde a gestos pero puede no registrar las interacciones",
  AUTOMATIC_INTERACTION: "Un temporizador registra interacciones aunque nadie haya tocado el anuncio",
  CHECK_INCOMPLETE: "No se pudo completar esta revisión de composición",
  TEXT_OVERFLOW: "Un texto se desborda o queda cortado",
  TARGET_TOO_SMALL: "Un área interactiva es demasiado pequeña para tocarla con comodidad (mínimo 24 × 24 px)",
};

export const isQualityWarningList = (x: unknown): x is string[] =>
  Array.isArray(x) && x.length <= 30 && x.every((w) => typeof w === "string" && w.length > 0 && w.length <= 100);

/** `CODE:tag#id@4s` → "<text> (a los 4 s)". Unknown codes are shown generically, never raw. */
export function qualityWarningText(warning: string): string {
  const code = warning.split(":")[0] ?? "";
  const seconds = /@([\d.]+)s$/.exec(warning)?.[1];
  const text = TEXTS[code] ?? "La vista previa encontró un posible problema de composición";
  return seconds ? `${text} (a los ${seconds.replace(".", ",")} s).` : `${text}.`;
}
